module.exports = __webpack_public_path__ + "img/desktop-neck-13_18x832.24013e2a.png";